import 'braid-design-system/reset';
import { HirerAuthProvider } from '@seek/hirer-auth-react';
import { HirerApolloProvider } from '@seek/hirer-graphql-react';
import { UivBanner, useIsNVLEnabled } from '@seek/uiv-banner';
import { VocabProvider } from '@vocab/react';
import { BraidProvider, ToastProvider } from 'braid-design-system';
import apac from 'braid-design-system/themes/apac';
import seekJobs from 'braid-design-system/themes/seekJobs';

import { URL_HIRER_GRAPH, URL_HIRER_GRAPH_STAGING } from 'src/constants/urls';
import { useConfig } from 'src/modules/ConfigProvider';

import { RouterLink } from './Components/RouterLink';
import { Root } from './Root/Root';

export default () => {
  const { locale, site, environment, appVersion, branch } = useConfig();
  const isNVLEnabled = useIsNVLEnabled(false);

  return (
    <VocabProvider language={locale}>
      <BraidProvider
        theme={isNVLEnabled ? seekJobs : apac}
        linkComponent={RouterLink}
      >
        <HirerAuthProvider>
          <HirerApolloProvider
            appName="user-management"
            site={site}
            uri={
              environment === 'development'
                ? URL_HIRER_GRAPH_STAGING
                : URL_HIRER_GRAPH
            }
          >
            <ToastProvider>
              <UivBanner
                applicationName="user-management"
                branch={branch}
                version={appVersion}
              />
              <Root />
            </ToastProvider>
          </HirerApolloProvider>
        </HirerAuthProvider>
      </BraidProvider>
    </VocabProvider>
  );
};
